import React from "react";
import { Subscribe } from "unstated";
import PlayerContainer from "../state";

export class ShowSthana extends React.Component {
   /*
    constructor(props) {
        super(props);
        this.state = { showed: true };
        this.toggleShow = this.toggleShow.bind(this);
    }

    toggleShow() {
        this.setState({ showMS: !this.state.showMS});
    }
*/
    render() {
        return (
            <form>
            <Subscribe to={[PlayerContainer]}>
            {playSwara =>(
                <div>
                <label className="checkbox">
                    <input type="checkbox" checked={playSwara.state.showMS} onChange={() => {playSwara.toggleShow() }}>
                    </input>
                    <span style={{marginLeft: "0.5em"}}>Keezh / Mandara Sthaayi</span>
            {console.log("checkbox:",playSwara.state.showMS)}
                </label>
                <label className="checkbox">
                    <input type="checkbox" checked={playSwara.state.showTS} onChange={() => {playSwara.toggleShowT() }}>
                    </input>
                    <span style={{marginLeft: "0.5em"}}>Mel / Taara Sthaayi</span>
            {console.log("checkbox:",playSwara.state.showTS)}
                </label>
                </div>
                )}
                </Subscribe>
            </form>
        )
    }
}
export let showSthana = new ShowSthana();